import URI from "urijs"
import * as qs from "qs"
export const ChangeUrlQueryValues = (path:string, newvalues) => {
  const uri = URI(path);
  const param = qs.parse(uri.query())
  const newParam = qs.stringify({ ...param, ...newvalues })
  return `${uri.path()}?${newParam}`;
}
export const GetQueryValues = (path: string) => {
  return qs.parse(URI(path).query())
}